import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '@vst/beam';
import { View } from 'react-native';

import { getAllDetails, selectStreamOnPromo, setCurrentPage, Pages as StreamOnPages } from '@app/redux/streamOnPromo';

import { StreamOnNavigator } from './pages';

export const Stream = (): JSX.Element => {
  const dispatch = useDispatch();
  const {
    offerDetails: { loading },
  } = useSelector(selectStreamOnPromo);

  React.useEffect(() => {
    dispatch(getAllDetails());
    dispatch(setCurrentPage(StreamOnPages.orderReview));
  }, [dispatch]);

  if (loading) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size="large" />
      </View>
    );
  }

  return <StreamOnNavigator />;
};

export default Stream;
